import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const displaySuccessSharingAlert = (recipientUrl, appName) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "shareWithThirdPartyComponentLibrary.alerts.success.title"
    }),
    message: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: 'shareWithThirdPartyComponentLibrary.alerts.success.message_jsx',
        elements: {},
        options: {
          appname: appName
        }
      }), !!recipientUrl && /*#__PURE__*/_jsx(Button, {
        external: true,
        href: recipientUrl,
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: 'shareWithThirdPartyComponentLibrary.alerts.success.viewInAppButton_jsx',
          elements: {},
          options: {
            appname: appName
          }
        })
      })]
    }),
    type: 'success'
  });
};
export const displayErrorAlert = (titleTranslationKey, messageTranslationKey) => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text(titleTranslationKey),
    message: I18n.text(messageTranslationKey),
    type: 'danger'
  });
};